module.exports = __webpack_public_path__ + "static/media/MothDark_jacket.ac42b868.jpg";